export const BALANCES = {
    MAIN_BALANCE: 'PNRNg7fkXUvn1bJdrTGF',
    CASH_REGISTER: 'CASH_REGISTER',
    EXTERNAL_BALANCE: 'X07JqaEEOCuFYgqOVJBs',
    TAX_BALANCE: '0haQVkIjykDBCwBf35pv',
};
